export const SCROLL_TO_HASH_MESSAGE_TYPE = 'embeddedConfluenceScrollToHash';
